/**
 * Validade Status Chip Component
 * Displays a colored chip based on the EPC validity status
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as ValidIcon,
  Warning as ExpiringSoonIcon,
  Error as ExpiredIcon,
} from '@mui/icons-material';
import { isExpired, isExpiringSoon, getDaysUntilExpiration } from '../../../types/epc';

interface ValidadeStatusChipProps {
  validade: string;
  size?: 'small' | 'medium';
}

export const ValidadeStatusChip: React.FC<ValidadeStatusChipProps> = ({
  validade,
  size = 'small',
}) => {
  const expired = isExpired(validade);
  const expiringSoon = isExpiringSoon(validade);
  const daysLeft = getDaysUntilExpiration(validade);

  if (expired) {
    return (
      <Tooltip title={`Validade vencida há ${Math.abs(daysLeft)} dias`}>
        <Chip
          icon={<ExpiredIcon />}
          label="Vencido"
          size={size}
          color="error"
        />
      </Tooltip>
    );
  }

  if (expiringSoon) {
    return (
      <Tooltip title={`Vence em ${daysLeft} dias`}>
        <Chip
          icon={<ExpiringSoonIcon />}
          label={`Vence em ${daysLeft}d`}
          size={size}
          color="warning"
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={`Válido por mais ${daysLeft} dias`}>
      <Chip
        icon={<ValidIcon />}
        label="Válido"
        size={size}
        color="success"
        variant="outlined"
      />
    </Tooltip>
  );
};

export default ValidadeStatusChip;
